import {
  ResponsiveSanityImage,
  ResponsiveSanityImageProps,
  SectionContainer,
  SanityImageRatio
} from "@silversea-ssc/ui-components-react";
import React from "react";
import { CruiseSegment } from "src/templates/SpecialVoyage/SpecialVoyage";
import * as styles from "./CruiseSegmentSummary.module.scss";
import { buildCruiseName } from "../../utils/cruise";
import DateOnlyFormat from "components/DateOnlyFormat";

export interface CruiseSegmentSummaryProps {
  segment: CruiseSegment;
  map?: ResponsiveSanityImageProps["image"];
}

const CruiseSegmentSummary: React.FC<CruiseSegmentSummaryProps> = ({
  segment,
  map
}) => {
  return (
    <div className={styles.root}>
      <SectionContainer
        backgroundColor="transparent"
        dataContentName="cruise_segment_summary"
      >
        <div className={styles.dates}>
          <DateOnlyFormat
            value={segment.data?.departureDate}
            format={{
              month: "long",
              day: "numeric"
            }}
          />{" "}
          -{" "}
          <DateOnlyFormat
            value={segment.data?.arrivalDate}
            format={{
              month: "long",
              day: "numeric"
            }}
          />
        </div>
        <h3 className={styles.name}>{buildCruiseName(segment)}</h3>
        {map && (
          <div className={styles.mapContainer}>
            <SanityImageRatio image={map} className={styles.map} ratio="auto">
              <ResponsiveSanityImage
                image={map}
                defaultWidth={900}
                defaultHeight={500}
                fit="original"
              />
            </SanityImageRatio>
          </div>
        )}
      </SectionContainer>
    </div>
  );
};

export default CruiseSegmentSummary;
